import { UIComponentViewImpl } from '../uicomponentview';
import * as React from 'react';
import { UIDataModel, UIComponentHandler } from '../uicomponent';
import { MobileMenuComponentProps, MobileMenuComponentState, MobileMenuComponentHandler } from './mobilemenucomponent';
import { MobileMenuCSSStyle } from './mobilemenucss';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { DropDownDto } from '../../../core/dto/dropdown/dropdowndto';
import { RoutingFeatures } from '../../components/navigation/routingfeature';
import { LoaderWrapperComponent } from '../../components/popup/loaderwrappercomponent';
import { LoaderComponent } from '../loader/loadercomponent';
import { LanguageComponent } from '../header/language/languagecomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { ImageLoaderCSSStyle } from '../imageloader/imageloadercss';
import { BaseContext } from '../../../utils/basecontext';
import { MenuCategoriesImageLoaderCSSStyleImpl } from './menucategoriesimageloadercss';
import { Fonts } from '../../../utils/resources/fonts';
import './mobilemenu-style.css';


export class MobileMenuViewImpl extends UIComponentViewImpl<UIDataModel>
{
    imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = new MenuCategoriesImageLoaderCSSStyleImpl(context);
    }

    bindHandlers()
    {
        this.onOpenMenu = this.onOpenMenu.bind(this);
        this.onCloseMenu = this.onCloseMenu.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.showCategories = this.showCategories.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
    }
    draw(props: MobileMenuComponentProps, state: MobileMenuComponentState, cssStyle: MobileMenuCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return(
            <>
            {
                !state.isMenuOpen ?
            
              <div id="mobile-menu-hamburger_close"  style={{width: "10%"}} onClick={this.onOpenMenu}>
                <img style={{cursor: "pointer",width:'25px',height:"21px", marginTop:'15px',marginLeft:'0px'}} src={props.context.getResources().getImage("hamburger.svg")}  />
            </div> :
            
            <div id="mobile-menu-hamburger_open"  style={{width: "10%"}} onClick={this.onOpenMenu}>
            <img style={{cursor: "pointer",width:'25px',height:"21px", marginTop:'15px',marginLeft:'0px'}} src={props.context.getResources().getImage("hamburger.svg")}  />
        </div> }
            <div style={cssStyle.getSideBarOpen(state.isMenuOpen)}> 
                <div style={{width: "100%", padding:"5px"}}>
                    <div style={cssStyle.getLogoWrapperCSSStyle()}>
                        <img style={{cursor: "pointer",width:'auto',height:"30px",marginTop:'0px',marginLeft:'10px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                    </div>
                    <div id="mobile-menu-close-icon" style={cssStyle.getCloseIconDivCSSStyle()}>
                        <img style={cssStyle.getCloseIconCSSStyle()} src={props.context.getResources().getImage("close_gray.svg")} onClick={this.onCloseMenu} />
                    </div>
                </div>
                <div style={{paddingLeft:"15px", paddingRight: "15px"}}>
                    <LanguageComponent onLanguageChange={this.onLanguageChange} context={props.context} fontSize={props.context.getResources().getFont(Fonts.h8)}/>
                </div>
            <table style={cssStyle.getWrapperCSSStyle()}>
            <tbody style={{textAlign: "center",width: "100%", height: "100%", padding:"15px"}}>
                {
                    state.listOfOptions.map((dropDownDto: DropDownDto, index: number)=>
                    {
                        return  <><tr id="mobile-menu-title" key={index} style={cssStyle.getInnerWrapperCSSStyle()} onClick={()=>this.onOptionSelected(dropDownDto)}>

                                <td style={cssStyle.getIconNameLabelCSSStyle()}>
                                {
                                    dropDownDto.getId() === "About" &&
                                    <a target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("AboutAPPURL")}>
                                        <label style={{fontWeight:300, letterSpacing: 0, color: "#000000", cursor:'pointer', margin:'0px 7px 0px 7px'}}>
                                            {dropDownDto.getTitle()}
                                        </label>
                                    </a>
                                }
                                {
                                    dropDownDto.getId() !== "About" &&
                                    <label style={{fontWeight:300, letterSpacing: 0,color: "#000000", cursor:'pointer', margin:'0px 7px 0px 7px'}}>
                                        {dropDownDto.getTitle()}
                                        
                                    </label>
                                        
                                }
                                <div style={cssStyle.getDividerCSSStyle()}/>
                                </td>
                            </tr>
                            {
                                dropDownDto.getId() === RoutingFeatures.MENU_CATEGROIES  && state.isTuneSelected &&
                                state.categories.map((categoryDto: CategoryDto, id: number)=>
                                {
                                 return <tr key={id} style={cssStyle.getCategoriesInnerWrapperCSSStyle()} onClick={()=>this.onCategorySelected(categoryDto)}>
                                            {/* <td style={cssStyle.getIconDivCSSStyle()}>   
                                            <ImageLoaderComponent defaultImageName={"category_default_image.jpg"} imagePath={categoryDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> 
                                            </td> */}
                                            <td id="mobile-menu-title" style={cssStyle.getIconNameLabelCSSStyle()} >
                                                <label style={{fontWeight:300, letterSpacing: 0,color: "#000000", cursor:'pointer', margin:'0px 7px 0px 7px'}}>
                                                    {categoryDto.getTitle()}
                                                </label>
                                            </td>
                                            </tr>;
                                    })
                               
                        }
                            </>;
                    })
                }
            </tbody>
            </table>
          
            </div>

            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
       );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    
    private onOpenMenu()
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).toggleMenu(true);
    }

    private onCloseMenu()
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).toggleMenu(false);
    }

    private showCategories()
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).toggleCategories(!(this.getUIState() as MobileMenuComponentState).isTuneSelected);
    }

    private onLanguageChange(languageConst: LanguageConst)
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).onLanguageChange(languageConst);
    }

    private onOptionSelected(dropDownDto: DropDownDto)
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).onMyAccountOptionClicked(dropDownDto);
    }

    private onCategorySelected(categoryDto: CategoryDto): void
    {
        (this.getUIComponentHandler() as MobileMenuComponentHandler).onCategoriesSelected(categoryDto.getTitle());
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/mobilemenu/mobilemenuview.tsx